import CustomBoxHeader from "../../../CommonComponents/CustomBoxHeader";
import styles from "./CompanyDetails.module.css";
import { Row, Col, Spin } from "antd";
import { useRef, useState } from "react";
import { GoPencil } from "react-icons/go";

const CompanyDetails = ({ data, loading, refatchData }) => {
  const divRef = useRef(null);

  const companyInformaton = [
    {
      label: "First name",
      value: data?.firstName,
    },
    {
      label: "Last name",
      value: data?.lastName,
    },
    {
      label: "Dob",
      value: data?.dob,
    },
    {
      label: "Gender",
      value: data?.gender,
    },
    {
      label: "Email address",
      value: data?.emailAddress,
    },
    {
      label: "Phone",
      value: data?.phoneNumber,
    },
    {
      label: "Address",
      value: data?.address,
    },
    {
      label: "State/City",
      value: data?.state,
    },
    {
      label: "Country",
      value: data?.country,
    },
    {
      label: "Postcode/Zip",
      value: data?.postalCode,
    },
  ];

  const viewLivePage = () => {
    window.open("https://indexscore.com/enterprise-profile/" + data._id);
  };

  return (
    <div className={styles.column_wrap}>
      <div className={styles.left_col_wrap} ref={divRef}>
        <div className={styles.box_wrap_2}>
          {loading ? (
            <div className={styles.loader_wrap}>
              <Spin />
            </div>
          ) : (
            <>
              <CustomBoxHeader
                title={"Personal Information"}
                // action={handleEdit}
              />
              <Row className={styles.data_wrap}>
                <Col xs={24} sm={24} md={8} lg={6} xl={5}>
                  <div className={styles.picture_label}>
                    Profile Picture <GoPencil />
                  </div>
                  <img
                    className={styles.profile_img_wrap}
                    // onClick={handleEditPicProfile}
                    src={data?.profileImage?.docs}
                    alt="profile pic"
                  />
                </Col>
                <Col xs={24} sm={24} md={16} lg={18} xl={19}>
                  <Row gutter={[8, 24]}>
                    {companyInformaton.map((item) => {
                      return (
                        <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                          <div>
                            <div className={styles.label}>{item.label}</div>
                            <div className={styles.info}>{item.value}</div>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                </Col>
              </Row>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompanyDetails;
